import { inspectionsService } from '@/services/inspections';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

interface UseRecordsInspectionOptions {
  enabled?: boolean;
}

export function useRecordsInspection(
  policyId: string | null | undefined,
  inspectionId: string | null | undefined,
  options: UseRecordsInspectionOptions = {}
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: ['inspection-records', policyId, inspectionId],
    queryFn: async () => {
      const response = await inspectionsService.getInspectionsRecordsByPolicyId(
        policyId,
        inspectionId
      );

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar inspeções');
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
    enabled,
  });
}
